import { svg } from "lit";
const icon = svg `<path d="M23.9999 31.8307L15.7154 23.5462L17.3462 21.9346L22.8654 27.4347V9H25.1346V27.4347L30.6537 21.9346L32.2845 23.5462L23.9999 31.8307ZM9 38.9999V29.85H11.2692V36.7307H36.7307V29.85H38.9999V38.9999H9Z" fill="currentColor"/>`;
export default icon;
